import React from "react";
import {Row, Col, Popover} from "antd";
import myEduOwl from "../../../assets/images/myedu_owl.png";
import styles from './index.module.scss';
import {WhatsAppOutlined, MailOutlined, PhoneOutlined} from '@ant-design/icons'

const CustomFooter = () => {
  return (
    <Row
      className={styles.footerMainRow}
      gutter={16}
    >
      <Col xs={24}>
        <h2 className={styles.footerTitle}>Ti servono altre info? <br/> Contattaci!</h2>
      </Col>
      <Col
        className={styles.footerContentCol}
        xs={24}
        lg={8}
      >
        <a
          className={styles.footerLink}
          href="mailto:team@myedu.it"
        >
          <MailOutlined className={styles.footerIcon} />
          team@myedu.it
        </a>
      </Col>
      <Col
        className={styles.footerContentCol}
        xs={24}
        lg={8}
      >
        <a
          className={styles.footerLink}
          href="tel:00390230076303"
        >
          <PhoneOutlined className={styles.footerIcon} />
          02 30076303
        </a>
      </Col>
      <Col
        className={styles.footerContentCol}
        xs={24}
        lg={8}
      >
        <a
          className={styles.footerLink}
          href="https://api.whatsapp.com/send?phone=00393278882745"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppOutlined className={styles.footerIcon} />
          327 8882745
        </a>
      </Col>
      <Col
      className={styles.footerOwlCol}
        xs={24}
      >
        <Popover
          placement="left"
          content="Clicca su di me per tornare in cima! :)"
        >
          <img
            onClick={() => {
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
            }}
            alt="Gufo MyEdu"
            src={myEduOwl}
            className={styles.footerOwl}
          />
        </Popover>
      </Col>
    </Row>
  )
}

export default CustomFooter;